import { NoCabFilled, RescheduleRide } from '@repo/shared/icons';
import { useState } from 'react';
import type { BookingSuccessResponse } from '@/api';
import { SectionHeader } from '@/components/section-header';
import { Cancellation } from './cancellation';
import { ListCard } from './list-card/list-card';
import { Reschedule } from './reschedule';

interface ModifyBookingProps
	extends React.ComponentPropsWithoutRef<'div'>,
		Pick<
			BookingSuccessResponse['data'],
			'cancellationDetail' | 'rescheduleDetail' | 'cabDetail' | 'rideDetails'
		> {}

export const ModifyBooking = (props: ModifyBookingProps) => {
	const [showCancellation, setShowCancellation] = useState(false);
	const [showReschedule, setShowReschedule] = useState(false);
	// Prevents modal from closing when router.invalidate() causes re-render
	// that temporarily changes cancellationDetail?.allowed to false
	const [preventClose, setPreventClose] = useState(false);
	const {
		cancellationDetail,
		rescheduleDetail,
		cabDetail,
		rideDetails,
		...rest
	} = props;
	const showCancelRide = cancellationDetail?.allowed || preventClose;
	const showRescheduleRide = rescheduleDetail?.allowed;
	if (!showCancelRide && !showRescheduleRide) {
		return null;
	}

	return (
		<div className="p-20 pb-10 bg-primary" {...rest}>
			<SectionHeader title="Modify Booking" />
			{showCancelRide && (
				<ListCard
					title="Cancel Ride"
					subtitle="Cancel for free till 30 min before pickup"
					icon={<NoCabFilled />}
					onClick={() => setShowCancellation(true)}
					className="border-b border-tertiary last-of-type:border-b-0"
				/>
			)}
			{showRescheduleRide && (
				<ListCard
					title="Reschedule Ride"
					subtitle="Change pickup date and time for free till 30 min before pickup"
					icon={<RescheduleRide />}
					onClick={() => setShowReschedule(true)}
				/>
			)}
			<Cancellation
				open={showCancellation}
				onModalClosed={() => {
					setShowCancellation(false);
					setPreventClose(false);
				}}
				onRouterOperationStart={() => setPreventClose(true)}
			/>
			<Reschedule
				open={showReschedule}
				tripDetail={{
					rideDetails,
					cabDetail,
					rescheduleDetail,
				}}
				onModalClosed={() => {
					setShowReschedule(false);
					setPreventClose(false);
				}}
				onRouterOperationStart={() => setPreventClose(true)}
			/>
		</div>
	);
};
